// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1Cow0","colMin":"styles_colMin__1R1I3","colCheckbox":"styles_colCheckbox__2MSGg"};